module.exports = __webpack_public_path__ + "img/restaurantfront.0531a29c.jpg";